import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { PartnerSuspendedBanner, usePartnerAccess, type PartnerPerm } from "@/entities/partner";

/**
 * 渠道后台路由门(OEM 第二批 A4 / A6):按 /me 的 partnerPerms 判这一页的权限点,无权 → /403;
 * 渠道被暂停时顶上挂「后台只读」横幅。/me 没回来前不渲染页面(免得先发一串必 403 的请求)。
 * 服务端每个接口仍独立判权,这里只是体验层。
 */
export function PartnerRoute({ perm, children }: { perm: PartnerPerm; children: ReactNode }) {
  const access = usePartnerAccess();
  if (!access.ready) {
    return <div className="py-20 text-center text-sm text-muted-foreground">…</div>;
  }
  if (!access.can(perm)) return <Navigate to="/403" replace />;
  return (
    <>
      <PartnerSuspendedBanner />
      {children}
    </>
  );
}
